var mouseDown = false,
    mousex = 0,
    mousey = 0,
  deltaX = 0,
  deltaY = 0;

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const manager = new LoadingManager();
manager.onLoad = function ( ) {
  var children = [].slice.call(document.getElementsByClassName("front-page-container")[0].children);
  var current = 1;
      var subChildren1 = [].slice.call(children[0].children);
      for(let y = 0; y < subChildren1.length; y++)
        {
          if (subChildren1[y].firstElementChild)
          {
            sleep(current * 500).then(() => { subChildren1[y].classList.add("anim1"); console.log(subChildren1[y]) });
            current++;
            console.log(subChildren1[y]);
          }
        }
        var subChildren2 = [].slice.call(children[1].children);
      for(let y = 0; y < subChildren2.length; y++)
        {
          if (subChildren2[y].firstElementChild)
          {
            sleep(current * 500).then(() => { subChildren2[y].classList.add("anim1"); console.log(subChildren2[y]) });
            current++;
            console.log(subChildren2[y]);
          }
        }
      current = 0;
  console.log(children);
  var children2 = [].slice.call(document.getElementsByClassName("front-page-container")[1].children);
        current = 0;
        for(let y = 0; y < children2.length; y++)
        {
          if (children2[y].firstElementChild)
          {
            sleep(current * 500).then(() => { children2[y].classList.add("anim1"); console.log(children2[y]) });
            current++;
            console.log(children2[y]);
          }
        }

  document.getElementById('glcanvas').classList.add("anim2");
  document.getElementsByClassName('front-page-container')[1].classList.add("anim1");
  document.getElementsByClassName('front-page-container')[0].classList.add("anim1");
};


  function onMouseDown(evt) {

    mouseDown = true;

}

function onMouseUp(evt) {

    mouseDown = false;
  mousex = 0;
  mousey = 0;
}

const fitCameraToObject = function ( camera, object, offset, controls ) {

  offset = offset;

  const boundingBox = new Box3();

  boundingBox.expandByObject( object );

  const maxDim = Math.max( boundingBox.max.x - boundingBox.min.x, boundingBox.max.y - boundingBox.min.y, boundingBox.max.z - boundingBox.min.z );
  const fov = camera.fov * ( Math.PI / 180 );

  let cameraZ = Math.abs( maxDim / 4 * Math.tan( fov * 2 ) ) * offset

  camera.position.z = cameraZ;

  const minZ = boundingBox.min.z;
  const cameraToFarEdge = ( minZ < 0 ) ? -minZ + cameraZ : cameraZ - minZ;

  camera.far = cameraToFarEdge * 3;
  camera.updateProjectionMatrix();
  if ( controls ) {

    // set camera to rotate around center of loaded object
    controls.target = center;

    // prevent camera from zooming out far enough to create far plane cutoff
    controls.maxDistance = cameraToFarEdge * 2;

    controls.saveState();

  } else {

 }
}

  function tellPos(e) {
    var x;
    var y;
    if(e.type == 'touchmove'){
        var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
        var touch = evt.touches[0] || evt.changedTouches[0];
        x = Math.floor(touch.pageX);
        y = Math.floor(touch.pageY);
      mouseDown = true;

    } else if (e.type == 'mousemove') {
        x = e.clientX;
        y = e.clientY;
    }
    
    var ratio = window.devicePixelRatio || 1;
    var w = screen.width * ratio;
    var h = screen.height  * ratio;
    if (mousex != 0 && mousey != 0)
    {
    deltaX = (x / w) - mousex;
    deltaY = ((y / h) * -1 + 1) - mousey;
    }
    mousex = x / w;
    mousey = (y / h) * -1 + 1;
}

var scanGlitchShader;
var wiggleGlitchShader;
var sineGlitchShader;
var postProcessingShader;
var edgeDetectShader;
var shinePass;

function main() {
  const canvas = document.getElementById("glcanvas");
  const renderer = new WebGLRenderer({ antialias: true, canvas, alpha: true });
  const composer = new EffectComposer(renderer);

  addEventListener("mousemove", tellPos, false);
  addEventListener("touchmove", tellPos, false);
  addEventListener("mousedown", onMouseDown, false);
  addEventListener("touchstart", onMouseDown, false);
  addEventListener("mouseup", onMouseUp, false);
  addEventListener("touchend", onMouseUp, false);

  const fov = camfov;
  const aspect = 2; // the canvas default
  const near = 0.01;
  const far = 11111;
  const camera = new PerspectiveCamera(fov, aspect, near, far);
  camera.position.z = camdist * 100;

  const scene = new Scene();

  setupLights();

  var logo;
  var menu;

  setPasses();

  const loader = new GLTFLoader(manager);
  loader.load(objlink, (root) => {
    logo = root.scene;
    logo.name = "MODEL";
    logo.scale.x = mscale;
    logo.scale.y = mscale;
    logo.scale.z = mscale;
    logo.position.x = mposx;
    logo.position.y = mposy;
    logo.position.z = mposz;
      logo.getObjectByName("MODEL").traverse(
        function (child)
        {
          if (child.type == "Mesh")
          {
          child.material.envMap = envmap;
            child.material.envMapIntensity = 1;
            child.material.needsUpdate = true;
          console.log(child);
          }
        }
      );
    scene.add(logo);
    fitCameraToObject(camera, root.scene, camdist);
  });

  function setupLights() {

    if (lightSetup == "1") {
      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(-3, 1, 4);
        scene.add(light);
      }

      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(3, 1, 4);
        scene.add(light);
      }
    }
    if (lightSetup == "2") {
      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(0, 0, 4);
        scene.add(light);
      }
    }
    if (lightSetup == "3") {
      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(-3, 3, 4);
        scene.add(light);
      }

      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(3, 3, 4);
        scene.add(light);
      }
      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(3, -3, 4);
        scene.add(light);
      }
      {
        const color = 0xffffff;
        const intensity = lightBrightness;
        const light = new DirectionalLight(color, intensity);
        light.position.set(-3, -3, 4);
        scene.add(light);
      }
    }
  }

  function setPasses() {
    composer.addPass(new RenderPass(scene, camera));


    if (edgedetect == true)
    {
      edgeDetectShader = new ShaderPass(EdgeDetectShader);
      composer.addPass(edgeDetectShader);
    }
    
    if (scanglitch == true) {
      scanGlitchShader = new ShaderPass(ScanGlitchShader);
      composer.addPass(scanGlitchShader);
    }

    if (wiggleglitch == true)
    {
      wiggleGlitchShader = new ShaderPass(WiggleGlitchShader);
      composer.addPass(wiggleGlitchShader);
    }

        if (sineglitch == true)
    {
      sineGlitchShader = new ShaderPass(SineGlitchShader);
      composer.addPass(sineGlitchShader);
    }
    
    if (glow == true)
    {
      var bloomPass = new TransparentBackgroundFixedUnrealBloomPass(new Vector2(window.innerWidth, window.innerHeight), glowstrength, glowradius, glowtreshold);
      composer.addPass(bloomPass);
    }

    if (shine == true)
    {
      shinePass = new ShaderPass(ShineShader);
      composer.addPass(shinePass);
    }
        
    if (channelseparation == true)
    {
      const channelSeparationShader = new ShaderPass(ChannelSeparationShader);
      composer.addPass(channelSeparationShader);
    }

    postProcessingShader = new ShaderPass(PostProcessingShader);
    composer.addPass(postProcessingShader);

       var fxaaPass = new ShaderPass(FXAAShader);

    fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( canvas.getBoundingClientRect().width * window.devicePixelRatio |1 );
				fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( canvas.getBoundingClientRect().height * window.devicePixelRatio | 1 );
    //composer.addPass(fxaaPass);

    const outputPass = new OutputPass();
    composer.addPass(outputPass);
  }

  function resizeRendererToDisplaySize(renderer) {
    const canvas = renderer.domElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const needResize = canvas.width !== width || canvas.height !== height;
    if (needResize) {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    console.log(canvas.getBoundingClientRect().width);
      var ratio = window.devicePixelRatio || 1;
    renderer.setSize(canvas.getBoundingClientRect().width * ratio, canvas.getBoundingClientRect().height * ratio, false);
    }
    return needResize;
  }


  let then = 0;
  let timeForShader = 0;
  let menuOffsetx = 0;
  let menuOffsety = 0;
  let rotx = 0;
  let roty = 0;
  let rotz = 0;
  let inertx = 0;
  let inerty = 0;
  let prevDeltaX = 0;
  let prevDeltaY = 0;
  function render() {
    var currentDate = new Date();
    var time = currentDate.getTime();

    if (scanglitch == true) {
      scanGlitchShader.uniforms.time.value = timeForShader;
    }

    if (wiggleglitch == true)
    {
      wiggleGlitchShader.uniforms.time.value = timeForShader;
    }

    if (sineglitch == true)
    {
      sineGlitchShader.uniforms.time.value = timeForShader;
    }

    if (edgedetect == true)
    {
      edgeDetectShader.uniforms.resolution.value = new Vector2(canvas.clientWidth * window.devicePixelRatio , canvas.clientHeight * window.devicePixelRatio );
      edgeDetectShader.uniforms.color.value = new Vector3(edgeDetectColor[0], edgeDetectColor[1], edgeDetectColor[2]);
      edgeDetectShader.uniforms.fillcolor.value = new Vector3(edgeDetectFillColor[0], edgeDetectFillColor[1], edgeDetectFillColor[2]);
      edgeDetectShader.uniforms.modeloverride.value = modeloverride;
    }

    if (shine == true)
    {
      shinePass.uniforms.exposure.value = shineexposure;
      shinePass.uniforms.decay.value = shinedecay;
      shinePass.uniforms.density.value = shinedensity;
      shinePass.uniforms.weight.value = shineweight;
    }
    
    time *= 0.001;
    const deltaTime = time - then;
    then = time;

    if (deltaTime < 100000)
    {
      timeForShader += deltaTime;
    }

    postProcessingShader.uniforms.brightness.value = brightness;
    postProcessingShader.uniforms.saturation.value = saturation;
    postProcessingShader.uniforms.hue.value = hue;

    if (resizeRendererToDisplaySize(renderer)) {
      const canvas = renderer.domElement;
      camera.aspect = canvas.clientWidth / canvas.clientHeight;
      camera.updateProjectionMatrix();
      var ratio = window.devicePixelRatio || 1;
      composer.setSize(canvas.getBoundingClientRect().width * window.devicePixelRatio, canvas.getBoundingClientRect().height * window.devicePixelRatio);
    }

    if (logo != null) {
      
      logo.rotation.x = mrotx;
      logo.rotation.y = mroty;
      logo.rotation.z = mrotz;
      
      if (interactability == 'lookatmouse' && canvas.clientWidth >= 900) {
        var fmousex = logo.position.x;
        var fmousey = logo.position.y;

        if (interlockx == false)
        {
          fmousex = mousex * lookatmousesens - lookatmousesens / 2;
        }
        if (interlocky == false)
        {
          fmousey = mousey * lookatmousesens - lookatmousesens / 2;
        }
        
        logo.lookAt(
          fmousex,
          fmousey,
          180
        );
        logo.rotation.x += mrotx;
        logo.rotation.y += mroty;
        logo.rotation.z += mrotz;
      }
      else if (interactability == 'draggable' || canvas.clientWidth < 900 && interactability == 'lookatmouse')
      {
        if (mouseDown == true)
        {
          if (interlockx == false)
          {
            inerty += deltaX * 0.1 * (lookatmousesens / 100);
          }
          if (interlocky == false)
          {
            inertx -= deltaY * 0.1 * (lookatmousesens / 100);
          }
        }

        if (inertx < 0.00001 && inerty < 0.00001)
        {
          rotx += mrotxt / 100;
          roty += mrotyt / 100;
          rotz += mrotzt / 100;
        }

        rotx += inertx;
        roty += inerty;
        inertx *= 0.95;
        inerty *= 0.95;

        prevDeltaX = deltaX;
        prevDeltaY = deltaY;
      }

      if (interactability != 'draggable')
      {
        rotx += mrotxt / 100;
        roty += mrotyt / 100;
        rotz += mrotzt / 100;
      }

      logo.rotation.x += rotx;
      logo.rotation.y += roty;
      logo.rotation.z += rotz;
    }

    if (menu != null) {
      menu.position.x -= menuOffsetx;
      menu.position.y -= menuOffsety;

      menuOffsetx = mousex * 11 * (1.5 - dist(0.1, 0.5, mousex, 0.5));
      menuOffsety = mousey * 5 * (1.5 - dist(0.1, 0.5, 0.1, mousey));

      menu.position.x += menuOffsetx;
      menu.position.y += menuOffsety;

      menu.lookAt(mousex * 100 - 100 / 2, mousey * 30 - 30 / 2, 180);
      menu.rotation.y += 0.8;
    }

    composer.render(deltaTime);

    requestAnimationFrame(render);
  }

  function dist(x1, y1, x2, y2) {
    var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    return distance;
  }
  requestAnimationFrame(render);
}
main();
